import { ga } from '../../../engine/ga-sidecar'
import { chessUiMessage } from './chessUiMessage-sidecar'

export function onNews() {
  ga.action('click', 'news')
  // \n\nAdditional Testing:
  let text = ''
  text += '\n\n0.5.1   5/27/2021'
  text += '\n- Jam version with AI and rules'
  text += '\n\n0.1.1   5/21/2021'
  text += '\n- Alpha playtest'
  chessUiMessage.setText('News', text)
  chessUiMessage.setOpen(true)
}
